import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and tagline */}
          <div className="md:col-span-1">
            <Link href="/" className="inline-block mb-4">
              <Image
                src="/personalia-logo-white.svg"
                alt="Personalia Logo"
                width={160}
                height={40}
              />
            </Link>
            <p className="text-gray-300 text-sm">
              Generate high-quality, personalized media assets directly from Adobe InDesign templates.
            </p>
          </div>

          {/* Links - Column 1 */}
          <div>
            <h3 className="text-lg font-bold mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/" className="text-gray-300 hover:text-white transition-colors">
                  Overview
                </Link>
              </li>
              <li>
                <Link href="/pricing" className="text-gray-300 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Links - Column 2 */}
          <div>
            <h3 className="text-lg font-bold mb-4">Developers</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/integrations" className="text-gray-300 hover:text-white transition-colors">
                  Integrations
                </Link>
              </li>
              <li>
                <a 
                  href="https://developer.personalia.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  API Documentation
                </a>
              </li>
            </ul>
          </div>

          {/* Links - Column 3 */}
          <div>
            <h3 className="text-lg font-bold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link href="https://www.xmpie.com/about-xmpie/company/" className="text-gray-300 hover:text-white transition-colors">
                  About XMPie
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.xmpie.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <Link href="/terms-of-service" className="text-gray-300 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a 
                  href="https://help.xmpie.com/Personalia/en/index.htm#t=Overview.htm"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Help Center
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA 
        <div className="mt-12 mb-10 py-8 px-6 bg-gray-800 rounded-lg text-center">
          <h3 className="text-xl font-bold mb-2">Ready to automate your creative workflows?</h3>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Join the Personalia beta program and transform how you create personalized media assets.
          </p>
          <a href="https://dashboard.personalia.io/signup" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            Join for free
          </a>
        </div>
        */} 

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 mt-8 text-sm text-gray-400 flex flex-col md:flex-row justify-between">
          <p>© {new Date().getFullYear()} XMPie. All rights reserved.</p>
          <p>Personalia is service provided by <a href="https://www.xmpie.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">XMPie, A CareAR Company</a>.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
